module.exports = __webpack_public_path__ + "media/images/flags/ml-96980dee5558ff4b27cd8b2c19398f14.svg";